export default {
  hero_title: "猫咪社区",
  hero_subtitle: "爱猫人的温暖聚集地",
  hero_description: "汇聚海量猫咪养护经验、萌猫图片分享、健康问答与领养信息，与数十万铲屎官一起交流，让每一只猫咪都被温柔对待。",
  hero_cta: "开始探索",
  hero_search: "搜索猫咪相关话题...",
  section_categories: "探索分类",
  section_categories_desc: "六大板块，全方位覆盖你的养猫需求",
  section_hot_articles: "热门文章",
  section_hot_articles_desc: "铲屎官们都在看的精选内容",
  section_stats: "社区数据",
  section_stats_desc: "猫咪社区，每天都在成长",
  stat_members: "注册会员",
  stat_articles: "文章总数",
  stat_daily: "日活跃",
  stat_adoptions: "成功领养",
  section_faq: "常见问题",
  section_faq_desc: "你可能想了解的事情",
  section_testimonials: "铲屎官说",
  section_testimonials_desc: "听听社区伙伴们的声音",
  join_community: "加入猫咪社区",
  join_community_desc: "与数十万铲屎官一起，分享养猫的快乐与知识",
  join_btn: "立即加入",
  footer_description: "猫咪社区是专为爱猫人士打造的互动平台，致力于为铲屎官们提供科学、实用、温暖的养猫知识和交流空间。",
  footer_links: "快速链接",
  footer_categories: "文章分类",
  footer_contact: "联系我们",
  footer_copyright: "© 2026 猫咪社区. All rights reserved.",
};